export const reorderCategories = (categories, fromIndex, toIndex) => {
  if (
    fromIndex === toIndex
    || fromIndex < 0
    || toIndex < 0
    || fromIndex >= categories.length
    || toIndex >= categories.length
  ) {
    return categories;
  }

  const reordered = [...categories];
  const [moved] = reordered.splice(fromIndex, 1);
  reordered.splice(toIndex, 0, moved);
  return reordered;
};


export const saveCategoryOrder = async (previous, next, save) => {
  try {
    const categories = await save(next.map(category => category.id));
    return { categories, error: null };
  } catch (error) {
    return { categories: previous, error };
  }
};
